import merge from 'deepmerge';
import Validator from './validator.abstract';
import { hasNativeDatePicker } from '../../stratis_datepicker';

class ChildDateValidator extends Validator {
    constructor(el, submitButton, options = {}) {
        const mergedOptions = merge({
            defaultErrorText: 'La date de naissance saisie n’est pas éligible au dispositif',
            classList: {
                fieldError: 'is-error-date',
            },
        }, options);

        super(el, submitButton, mergedOptions);
    }

    isDateNot18YearsOld(year, month, day) {
        let maxBirthDate = new Date();
        maxBirthDate = new Date(maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 18));
        const maxYear = maxBirthDate.getFullYear();
        const maxMonthOnMaxYear = maxBirthDate.getMonth() + 1;
        const maxDayOnMaxMonthOnMaxYear = maxBirthDate.getDate();

        if (year < 2003) {
            return false;
        }

        if (year > maxYear) {
            return true;
        }

        if (year === maxYear) {
            if (month > maxMonthOnMaxYear) {
                return true;
            }

            if (month === maxMonthOnMaxYear) {
                if (day >= maxDayOnMaxMonthOnMaxYear) {
                    return true;
                }
            }
        }

        return false;
    }

    validate() {
        const min = this.field.getAttribute('min');
        let date = this.field.value.split('-');

        if (!hasNativeDatePicker()) {
            date = this.field.value.split('/').reverse();
        }

        const year = date[0];
        const month = date[1];
        const day = date[2];

        if (min) {
            const minValueArray = min.split('-');
            const minYear = minValueArray[0];
            const minMonth = minValueArray[1];
            const minDay = minValueArray[2];

            return +minYear < +year
            || (+minYear === +year && +minMonth <= +month)
            || (+minYear === +year && +minMonth === +month && +minDay <= +day);
        }

        return true;
        // return date.length < 3 || this.isDateNot18YearsOld(+year, +month, +day);
    }
}

export default class ChildDatelValidatorFactory {
    static create(form, selector, submitButton, options) {
        const validatorsArray = [...form.querySelectorAll(selector)];

        return validatorsArray.map((el) => {
            return new ChildDateValidator(el, submitButton, options || {});
        });
    }
}
